var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAiSpark = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.814 8.362a6.878 6.878 0 00-.533-.12l-.008-.002-.01-.002-.066-.012-.011-.002c-.248-.047-.248-.401 0-.448l.011-.002.067-.012.01-.002.007-.001a7.89 7.89 0 00.533-.121A6.843 6.843 0 007.759 2.28l.001-.008.002-.01.012-.064.002-.013c.047-.248.401-.248.448 0l.002.011.012.067.002.01.001.007a7.89 7.89 0 00.121.533 6.838 6.838 0 005.357 4.945l.008.001.01.002.066.012.011.002c.248.047.248.401 0 .448l-.047.009-.03.005-.01.002-.008.001a6.87 6.87 0 00-.916.236A6.845 6.845 0 008.24 13.72l-.001.008-.002.01-.004.022-.008.042-.002.013c-.047.248-.401.248-.448 0l-.002-.011-.012-.067-.002-.01-.001-.007a6.87 6.87 0 00-.236-.916 6.845 6.845 0 00-4.709-4.44z"
  })));
};
export default SvgAiSpark;